import { IconAED } from './AED';
import { IconAFN } from './AFN';
import { IconALL } from './ALL';
import { IconAMD } from './AMD';
import { IconANG } from './ANG';
import { IconAOA } from './AOA';
import { IconARS } from './ARS';
import { IconAUD } from './AUD';
import { IconAWG } from './AWG';
import { IconAZN } from './AZN';
import { IconBAM } from './BAM';
import { IconBBD } from './BBD';
import { IconBDT } from './BDT';
import { IconBGN } from './BGN';
import { IconBHD } from './BHD';
import { IconBIF } from './BIF';
import { IconBMD } from './BMD';
import { IconBND } from './BND';
import { IconBOB } from './BOB';
import { IconBRL } from './BRL';
import { IconBSD } from './BSD';
import { IconBTN } from './BTN';
import { IconBWP } from './BWP';
import { IconBYN } from './BYN';
import { IconBZD } from './BZD';
import { IconCAD } from './CAD';
import { IconCDF } from './CDF';
import { IconCHF } from './CHF';
import { IconCKD } from './CKD';
import { IconCLP } from './CLP';
import { IconCNY } from './CNY';
import { IconCOP } from './COP';
import { IconCRC } from './CRC';
import { IconCUC } from './CUC';
import { IconCUP } from './CUP';
import { IconCVE } from './CVE';
import { IconCZK } from './CZK';
import { IconDJF } from './DJF';
import { IconDKK } from './DKK';
import { IconDOP } from './DOP';
import { IconDZD } from './DZD';
import { IconEGP } from './EGP';
import { IconEHP } from './EHP';
import { IconERN } from './ERN';
import { IconETB } from './ETB';
import { IconEUR } from './EUR';
import { IconFJD } from './FJD';
import { IconFKP } from './FKP';
import { IconFOK } from './FOK';
import { IconGBP } from './GBP';
import { IconGEL } from './GEL';
import { IconGGP } from './GGP';
import { IconGHS } from './GHS';
import { IconGIP } from './GIP';
import { IconGMD } from './GMD';
import { IconGNF } from './GNF';
import { IconGTQ } from './GTQ';
import { IconGYD } from './GYD';
import { IconHKD } from './HKD';
import { IconHNL } from './HNL';
import { IconHRK } from './HRK';
import { IconHTG } from './HTG';
import { IconHUF } from './HUF';
import { IconIDR } from './IDR';
import { IconILS } from './ILS';
import { IconIMP } from './IMP';
import { IconINR } from './INR';
import { IconIQD } from './IQD';
import { IconIRR } from './IRR';
import { IconISK } from './ISK';
import { IconJEP } from './JEP';
import { IconJMD } from './JMD';
import { IconJOD } from './JOD';
import { IconJPY } from './JPY';
import { IconKES } from './KES';
import { IconKGS } from './KGS';
import { IconKHR } from './KHR';
import { IconKID } from './KID';
import { IconKMF } from './KMF';
import { IconKPW } from './KPW';
import { IconKRW } from './KRW';
import { IconKWD } from './KWD';
import { IconKYD } from './KYD';
import { IconKZT } from './KZT';
import { IconLAK } from './LAK';
import { IconLBP } from './LBP';
import { IconLKR } from './LKR';
import { IconLRD } from './LRD';
import { IconLSL } from './LSL';
import { IconLYD } from './LYD';
import { IconMAD } from './MAD';
import { IconMDL } from './MDL';
import { IconMGA } from './MGA';
import { IconMKD } from './MKD';
import { IconMMK } from './MMK';
import { IconMNT } from './MNT';
import { IconMOP } from './MOP';
import { IconMRU } from './MRU';
import { IconMUR } from './MUR';
import { IconMVR } from './MVR';
import { IconMWK } from './MWK';
import { IconMXN } from './MXN';
import { IconMYR } from './MYR';
import { IconMZN } from './MZN';
import { IconNAD } from './NAD';
import { IconNGN } from './NGN';
import { IconNIO } from './NIO';
import { IconNOK } from './NOK';
import { IconNPR } from './NPR';
import { IconNZD } from './NZD';
import { IconOMR } from './OMR';
import { IconPAB } from './PAB';
import { IconPEN } from './PEN';
import { IconPGK } from './PGK';
import { IconPHP } from './PHP';
import { IconPKR } from './PKR';
import { IconPLN } from './PLN';
import { IconPND } from './PND';
import { IconPRB } from './PRB';
import { IconPYG } from './PYG';
import { IconQAR } from './QAR';
import { IconRON } from './RON';
import { IconRSD } from './RSD';
import { IconRUB } from './RUB';
import { IconRWF } from './RWF';
import { IconSAR } from './SAR';
import { IconSBD } from './SBD';
import { IconSCR } from './SCR';
import { IconSDG } from './SDG';
import { IconSEK } from './SEK';
import { IconSGD } from './SGD';
import { IconSHP } from './SHP';
import { IconSLL } from './SLL';
import { IconSLS } from './SLS';
import { IconSOS } from './SOS';
import { IconSRD } from './SRD';
import { IconSSP } from './SSP';
import { IconSTN } from './STN';
import { IconSVC } from './SVC';
import { IconSYP } from './SYP';
import { IconSZL } from './SZL';
import { IconTHB } from './THB';
import { IconTJS } from './TJS';
import { IconTMT } from './TMT';
import { IconTND } from './TND';
import { IconTOP } from './TOP';
import { IconTRY } from './TRY';
import { IconTTD } from './TTD';
import { IconTVD } from './TVD';
import { IconTWD } from './TWD';
import { IconTZS } from './TZS';
import { IconUAH } from './UAH';
import { IconUGX } from './UGX';
import { IconUSD } from './USD';
import { IconUYU } from './UYU';
import { IconUZS } from './UZS';
import { IconVED } from './VED';
import { IconVES } from './VES';
import { IconVND } from './VND';
import { IconVUV } from './VUV';
import { IconWST } from './WST';
import { IconXAF } from './XAF';
import { IconXCD } from './XCD';
import { IconXOF } from './XOF';
import { IconXPF } from './XPF';
import { IconYER } from './YER';
import { IconZAR } from './ZAR';
import { IconZMW } from './ZMW';
import { IconZWL } from './ZWL';
import { IconArtsakh } from './Artsakh';
export const IconCurrency = {
    AED: IconAED,
    AFN: IconAFN,
    ALL: IconALL,
    AMD: IconAMD,
    ANG: IconANG,
    AOA: IconAOA,
    ARS: IconARS,
    AUD: IconAUD,
    AWG: IconAWG,
    AZN: IconAZN,
    BAM: IconBAM,
    BBD: IconBBD,
    BDT: IconBDT,
    BGN: IconBGN,
    BHD: IconBHD,
    BIF: IconBIF,
    BMD: IconBMD,
    BND: IconBND,
    BOB: IconBOB,
    BRL: IconBRL,
    BSD: IconBSD,
    BTN: IconBTN,
    BWP: IconBWP,
    BYN: IconBYN,
    BZD: IconBZD,
    CAD: IconCAD,
    CDF: IconCDF,
    CHF: IconCHF,
    CKD: IconCKD,
    CLP: IconCLP,
    CNY: IconCNY,
    COP: IconCOP,
    CRC: IconCRC,
    CUC: IconCUC,
    CUP: IconCUP,
    CVE: IconCVE,
    CZK: IconCZK,
    DJF: IconDJF,
    DKK: IconDKK,
    DOP: IconDOP,
    DZD: IconDZD,
    EGP: IconEGP,
    EHP: IconEHP,
    ERN: IconERN,
    ETB: IconETB,
    EUR: IconEUR,
    FJD: IconFJD,
    FKP: IconFKP,
    FOK: IconFOK,
    GBP: IconGBP,
    GEL: IconGEL,
    GGP: IconGGP,
    GHS: IconGHS,
    GIP: IconGIP,
    GMD: IconGMD,
    GNF: IconGNF,
    GTQ: IconGTQ,
    GYD: IconGYD,
    HKD: IconHKD,
    HNL: IconHNL,
    HRK: IconHRK,
    HTG: IconHTG,
    HUF: IconHUF,
    IDR: IconIDR,
    ILS: IconILS,
    IMP: IconIMP,
    INR: IconINR,
    IQD: IconIQD,
    IRR: IconIRR,
    ISK: IconISK,
    JEP: IconJEP,
    JMD: IconJMD,
    JOD: IconJOD,
    JPY: IconJPY,
    KES: IconKES,
    KGS: IconKGS,
    KHR: IconKHR,
    KID: IconKID,
    KMF: IconKMF,
    KPW: IconKPW,
    KRW: IconKRW,
    KWD: IconKWD,
    KYD: IconKYD,
    KZT: IconKZT,
    LAK: IconLAK,
    LBP: IconLBP,
    LKR: IconLKR,
    LRD: IconLRD,
    LSL: IconLSL,
    LYD: IconLYD,
    MAD: IconMAD,
    MDL: IconMDL,
    MGA: IconMGA,
    MKD: IconMKD,
    MMK: IconMMK,
    MNT: IconMNT,
    MOP: IconMOP,
    MRU: IconMRU,
    MUR: IconMUR,
    MVR: IconMVR,
    MWK: IconMWK,
    MXN: IconMXN,
    MYR: IconMYR,
    MZN: IconMZN,
    NAD: IconNAD,
    NGN: IconNGN,
    NIO: IconNIO,
    NOK: IconNOK,
    NPR: IconNPR,
    NZD: IconNZD,
    OMR: IconOMR,
    PAB: IconPAB,
    PEN: IconPEN,
    PGK: IconPGK,
    PHP: IconPHP,
    PKR: IconPKR,
    PLN: IconPLN,
    PND: IconPND,
    PRB: IconPRB,
    PYG: IconPYG,
    QAR: IconQAR,
    RON: IconRON,
    RSD: IconRSD,
    RUB: IconRUB,
    RWF: IconRWF,
    SAR: IconSAR,
    SBD: IconSBD,
    SCR: IconSCR,
    SDG: IconSDG,
    SEK: IconSEK,
    SGD: IconSGD,
    SHP: IconSHP,
    SLL: IconSLL,
    SLS: IconSLS,
    SOS: IconSOS,
    SRD: IconSRD,
    SSP: IconSSP,
    STN: IconSTN,
    SVC: IconSVC,
    SYP: IconSYP,
    SZL: IconSZL,
    THB: IconTHB,
    TJS: IconTJS,
    TMT: IconTMT,
    TND: IconTND,
    TOP: IconTOP,
    TRY: IconTRY,
    TTD: IconTTD,
    TVD: IconTVD,
    TWD: IconTWD,
    TZS: IconTZS,
    UAH: IconUAH,
    UGX: IconUGX,
    USD: IconUSD,
    UYU: IconUYU,
    UZS: IconUZS,
    VED: IconVED,
    VES: IconVES,
    VND: IconVND,
    VUV: IconVUV,
    WST: IconWST,
    XAF: IconXAF,
    XCD: IconXCD,
    XOF: IconXOF,
    XPF: IconXPF,
    YER: IconYER,
    ZAR: IconZAR,
    ZMW: IconZMW,
    ZWL: IconZWL,
    Artsakh: IconArtsakh,
};
//# sourceMappingURL=index.js.map